/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplateInstanceChangeStatusDialogContainer as TemplateInstanceChangeStatusDialog } from './TemplateInstanceChangeStatusDialog.container';
